import React, { useState, useEffect } from 'react';
import { Container, Alert, Form,Spinner, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../util/Api';
//import {isAuthenticated} from '../../util/Auth';
import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../app/slices/UserSlice';
import GuardrailEditForm from './components/GuardrailEditForm';

import * as Yup from 'yup';

const validationSchema = Yup.object({
    tag: Yup.string().required('a tag is required.'),
    email: Yup.string().email('please enter a valid email'),
    webhook: Yup.string().url('please enter a valid url')
});

const GuardrailForm = () => {

    const [errors, setErrors] = useState([]);
    const [app, setApp] = useState(null);
    const [sample, setSample] = useState(null);

    const [successMsg, setSuccessMsg] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [showLimitWarning, setShowLimitWarning] = useState(false);

    const [searchParams] = useSearchParams();
    let navigate = useNavigate();

    let { appKey, accountKey } = useParams();
    
    let sampleId = searchParams.get('sampleId');
    let typeId = searchParams.get('typeId');

    const currUserAccounts = useSelector(getUserAccounts);
    const currUserAccount = currUserAccounts.find(a => a.accountKey === accountKey);
    const currRoleId = currUserAccount ? currUserAccount.roleId : 0;


    let smWidth = 3;
    let mdWidth = 2;
    //let lgWidth = 6;

    //TODO: get users for the account
    //add buttons to edit account if role >= 2

    const thresholds = [0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1];

    useEffect(() => {
        document.title = `reconify guardrail form`;

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            sampleId: sampleId,
            typeId: typeId
        }

        let isAuthError = false;

        if (currRoleId < 2) {
            //don't have permissions - go to listing instead
            navigate(`/account/${accountKey}/guardrails/app/${appKey}`);
            return;
        }

        axios.post(apiUrl + '/guardrails/prepare',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    if (res.data.sample !== null) {
                        //check record count - if over - say you're at the limit
                        let recordCount = res?.data?.recordCount ? res.data.recordCount : 0;
                        if(currUserAccount.alertLimit <= recordCount){
                            //error - need to increase limit 
                            setShowLimitWarning(true);
                        }
                        else if(res.data.sample.sampleTypeId != 1){
                            //if sample is not text - show an error 
                            setErrors(['Guardrails currently can only be set on text.'])
                        }
                        else {
                            setSample(res.data.sample);
                        }          
                    }
                    if (res.data.app !== null) {
                        setApp(res.data.app);
                        document.title = `reconify guardrail form: ${res.data.app?.app}`;
                    }
                } else {
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    let redirectToDetail = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                //navigate('/login');
                                //errorMsgs.push('You have been logged out.');
                                //return;
                                redirectToLogin = true;
                                break;
                            case 'no-app':
                            case 'no-valid-app':
                                errorMsgs.push('The app could not be found.');
                                break;
                            case 'alert-exists':
                                redirectToDetail = true;
                                //not an auth error, but don't want to refresh page
                                isAuthError = true;
                                break;
                            case 'no-sample':
                            case 'no-results':
                                errorMsgs.push(`The ${typeId == 1 ? 'prompt' : 'response' } could not be found`);
                                break;
                            default:
                                errorMsgs.push('There was an error retrieving the information.');
                        }
                    });
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    } else if (redirectToDetail) {
                        if(res?.data?.alert !== null) {
                            navigate(`/account/${accountKey}/guardrails/app/${appKey}/detail/${res.data.alert.alertId}`);
                        } else {
                            navigate(`/account/${accountKey}/guardrails/app/${appKey}`);
                        }
                        return;
                    }
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
    }, [appKey, sampleId, typeId, navigate]);

    const submitAdd = (values, actions) => {
        //console.log("submitting form", values);
        setSubmitting(true)
        setErrors([]);
        setSuccessMsg(null);

        axios.post(apiUrl + '/guardrails/add', values, { withCredentials: true })
            .then((res) => {
                if (res.data.status === "ok") {

                    //setErrors([]);

                    //setSuccessMsg('The guardrail was successfully updated.')
                    
                    //redirect to detail
                    let alert = res.data.alert; 
                    navigate(`/account/${accountKey}/guardrails/app/${appKey}/detail/${alert.alertId}`)


                }
                else {

                    let errorMsgs = [];
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'no-permissions':
                                errorMsgs.push('You do not have permissions to create the guardrail.');
                                break;
                            case 'email-missing':
                            case 'webhook-missing':
                            case 'email-format':
                            case 'webhook-format':
                                    errorMsgs.push('Please enter a valid email address or webhook url.');
                                break;
                            default:
                                errorMsgs.push('There was an error creating the guardrail.');
                        }
                    });
                    setErrors(errorMsgs);
                }
                setSubmitting(false)
            })
            .catch((err) => {
                //console.error(err);
                //console.log('something went wrong');
                //clearAuthentication();
                //dispatch(clearUserStore());
                setErrors(['An error occurred while updating the guardrail.']);
                setSubmitting(false)
            });
    }

    return (
        <Container fluid>
            <div>
                <h3>Create Guardrail: {app !== null ? (<span className='head-subject'>{app.app}</span>) : null}</h3>
                {
                    errors.length > 0 ? (
                        <Alert variant='danger'>
                            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                        </Alert>
                    ) : (null)
                }
                {
                    showLimitWarning ? (
                    
                    <Alert>
                        <div>You are at the limit for the number of Guardrails included in your account. </div>
                        <div>To increase the limit, please contact <Link to={`/account/${accountKey}/support`}>Support</Link> for options</div>
                        <div><Link to={`/account/${accountKey}/guardrails/app/${appKey}`}>Manage Guardrails</Link></div>
                    </Alert>
                    
                    ) : (null)
                }
                {
                    sample !== null ? (
                        <div>
                            <h4>{typeId == 1 ? 'Prompt' : (typeId == 2 ? 'Response' : null)}</h4>
                            <div className='chat-bubble'>{sample.sample}</div>

                            

                            <h4 className='mt-4'>Guardrail</h4>
                            <div className='chart-card mt-3'>
                            
                    <Formik validationSchema={validationSchema}
                        onSubmit={submitAdd}
                        initialValues={{ sampleId: sampleId, typeId: typeId, tag: '', appKey: appKey, email: '', webhook: '', threshold: '0.7', isActive: 1 }}

                    >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            values,
                            touched,
                            isValid,
                            errors
                        }) => (
                            <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
                                <Form.Group controlId='guardrail-tag' className='mb-3'>
                                    <Form.Label>Tag <span className='required-field'>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="tag for guardrail"
                                        name="tag" value={values.tag} onChange={handleChange}
                                        isInvalid={touched.tag && errors.tag}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.tag}</Form.Control.Feedback>
                                </Form.Group>
                                
                                <Form.Group controlId='guardrail-threshold' className='mb-3'>
                                    <Form.Label>Similarity Threshold <span className='required-field'>*</span></Form.Label>
                                    <Form.Control as="select" name="threshold" onChange={handleChange} isInvalid={touched.threshold && errors.threshold}
                                        defaultValue={0.7}>
                                        <option value="">Select one</option>
                                        {
                                            thresholds.length > 0 ? (
                                                <>
                                                    {thresholds.map((t, i) => (<option key={'thresholds.' + i} value={t} >{t}</option>))}
                                                </>
                                            ) : (null)
                                        }
                                    </Form.Control>
                                    <Form.Text className='text-muted'>How similar on a scale of 0.5 to 1 to trigger alert, with 1 being closer to an exact match.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{errors.typeId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-email' className='mb-3'>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="email to receive notification"
                                        name="email" value={values.email} onChange={handleChange}
                                        isInvalid={touched.email && errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-webhook' className='mb-3'>
                                    <Form.Label>Webhook </Form.Label>
                                    <Form.Control type="text" placeholder="webhook to receive notification"
                                        name="webhook" value={values.webhook} onChange={handleChange}
                                        isInvalid={touched.webhook && errors.webhook}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.webhook}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-status' className='mb-3'>
                                    <Form.Label>Status <span className='required-field'>*</span></Form.Label>
                                    <Form.Control as="select" name="isActive" onChange={handleChange} isInvalid={touched.isActive && errors.isActive}
                                        defaultValue={1}>
                                        <option value="1">Active</option>
                                        <option value="0">Disabled</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors.isActive}</Form.Control.Feedback>
                                </Form.Group>
                                {/*<Form.Group controlId='guardrail-status' className='mb-3'>
                                    <Form.Check type="switch" name="isActive" label="Active" onChange={handleChange} value={1} defaultChecked={isActive == 1 ? true : false} />
                                </Form.Group>*/}
                                {submitting ? (
                                    <Button variant="info" disabled size='sm'><Spinner as="span" animation="border" size="sm" /> Creating...</Button>
                                ) : (
                                    <Button variant="primary" type="submit" size='sm'>Create Guardrail</Button>
                                )}
                            </Form>
                        )}
                    </Formik>
                </div>

                           


                        </div>
                    ) : (null)
                }
            </div>


        </Container>
    )
}



export default GuardrailForm;
